import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { ApiResponse } from '../../shared/types';

export interface FeedbackConfigurationRow {
  id: string;
  branch?: string;
  google_review_url: string | null;
  feedback_sms_delay_minutes: number;
  feedback_slug: string | null;
  feedback_sms_message: string | null;
  is_configured: boolean;
}

export interface FeedbackConfigurationPayload {
  google_review_url: string;
  feedback_sms_delay_minutes: number;
  feedback_sms_message: string;
  feedback_slug?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class FeedbackConfigurationService {
  private readonly apiService = inject(ApiService);

  private basePath(companyId: string, locationId?: string): string {
    const root = `admin/super-admin/companies/${companyId}`;
    return locationId ? `${root}/locations/${locationId}/feedback-configuration` : `${root}/feedback-configurations`;
  }

  listConfigurations(companyId: string): Observable<ApiResponse<FeedbackConfigurationRow[]>> {
    return this.apiService
      .getWithSuperAdminToken<FeedbackConfigurationRow[]>(this.basePath(companyId))
      .pipe(catchError(error => throwError(() => error)));
  }

  saveConfiguration(
    companyId: string,
    locationId: string,
    payload: FeedbackConfigurationPayload
  ): Observable<ApiResponse<FeedbackConfigurationRow>> {
    return this.apiService
      .patchWithSuperAdminToken<FeedbackConfigurationRow>(
        this.basePath(companyId, locationId),
        payload
      )
      .pipe(catchError(error => throwError(() => error)));
  }

  disableConfiguration(
    companyId: string,
    locationId: string
  ): Observable<ApiResponse<FeedbackConfigurationRow>> {
    return this.apiService
      .deleteWithSuperAdminToken<FeedbackConfigurationRow>(this.basePath(companyId, locationId))
      .pipe(catchError(error => throwError(() => error)));
  }
}
